import { formatDate, isValidDate, parseDate, parseISO } from "@repo/utils";
import { locale } from "../../../locale.svelte.js";

export function maybeFormatDate(value: string | undefined | null, includeTime = false) {
    const date = tryParseDate(value, includeTime);
    if (!!date && isValidDate(date)) {
        const formatter = Intl.DateTimeFormat(locale.current, {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: includeTime ? "2-digit" : undefined,
            minute: includeTime ? "2-digit" : undefined,
            second: includeTime ? "2-digit" : undefined,
        });
        return formatter.format(date);
    }

    return value;
}

export function maybeFormatISODate(value: string | undefined | null) {
    const date = tryParseDate(value);
    return date ? formatDate(date, "yyyy-MM-dd") : value;
}

function tryParseDate(value: string | undefined | null, includeTime = false) {
    if (!value) {
        return null;
    }

    let date: Date | null = null;
    if (value.match(/^\d{2}\.\d{2}\.\d{4}/)) {
        const pattern = includeTime ? "dd.MM.yyyy HH:mm:ss" : "dd.MM.yyyy";
        date = parseDate(value.slice(0, pattern.length), pattern, new Date());
    } else if (value.match(/^\d{4}-\d{2}-\d{2}/)) {
        date = parseISO(value);
    }

    return date;
}
